<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group label="Opportunity Name" label-for="mc-opp-name">
              <b-form-input id="mc-opp-name" type="text" readonly v-model="opportunityId.name" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Customer / Lead" label-for="cust-lead">
              <b-form-input id="cust-lead" type="text" readonly v-model="opportunityId.leadClientName" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Assigned To" label-for="assigned-to">
              <b-form-input id="assigned-to" type="text" readonly v-model="this.salesPersonName" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Status" label-for="status">
              <b-form-group label-for="status">
                <b-form-input id="status" type="text" readonly v-model="opportunityId.status" />
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Sales Stage" label-for="sales-stage">
              <b-form-input id="sales-stage" type="text" v-model="opportunityId.stage" readonly />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="amt" label="Amount">
              <div class="form-label-group">
                <b-form-input id="amt" type="number" readonly="" v-model="opportunityId.estimateValue"  />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Expected Close Date" label-for="close-date">
              <b-form-input id="close-date" value="2023-12-01" readonly v-model="expectedCloseDate" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Open Date" label-for="open-date">
              <b-form-input id="open-date" readonly v-model="createdon" />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Close Date" label-for="close-date">
              <b-form-input id="close-date" readonly v-model="closeDate" />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Days In Funnel" label-for="funnel-date">
              <b-form-input id="funnel-date" readonly v-model="opportunityId.funnel" />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Description" label-for="Description">
              <b-form-textarea id="Description" placeholder="Description" rows="3" v-model="opportunityId.description"
                readonly />
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12" class="justify-content-end d-flex" >
            <b-button variant="primary" @click="updateOpportunity">Save</b-button>
          </b-col> -->

        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>

import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BContainer,
  BCard,
  BSpinner,
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BFormDatepicker,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BContainer,
    BCard,
    BSpinner,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BFormFile,
    BFormDatepicker,
    BCardText,
  },
  data() {
    return {
      statusOptions: ["New", "In Progress", "Won", "Lost"],
      isSelectDisabled: true,
      isAmountReadOnly: true,
      salesPersonName: "",
      id: this.$route.params.id,
      createdon: null,
      closeDate: null,
      expectedCloseDate: null,

    }
  },

  computed: {
    ...mapGetters("opportunityModule", {
      opportunityId: "opportunityId",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),

  },

  methods: {
    ...mapActions("opportunityModule", ["getOpportunityByIdAction", "updateOpportuntiesAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),

    formatDate(timestamp) {
    return new Date(timestamp).toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  },


    success(message) {
            this.$swal({
                title: "Success!",
                text: message,
                icon: "success",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
            });
        },
        error(message) {
            this.$swal({
                title: 'Error!',
                text: message,
                icon: 'error',
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });
        },

    async updateOpportunity() {
      this.$swal({
          title: 'Updating Opportunity...',
          text: 'Please wait while the Opportunity is being updated...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
      try {
        const payloadEdit = {
          ...this.opportunityId,
        };
        await this.updateOpportuntiesAction({ id: this.id, payload: payloadEdit });
        this.success('Opportunity updated successfully!');
      } catch (error) {
        console.error("Error updating Opportunity:", error);
        this.error(error.response.data.message);
      } finally {
        this.submitting = false;
      }
    },

  },


  async mounted() {
    try {
      // Ensure both sets of data are loaded before proceeding
      await Promise.all([
        this.getSalesPersonListAction(), // Load sales persons list
        this.getOpportunityByIdAction(this.id)
        .then(() =>{
          this.createdon = this.formatDate(this.opportunityId.createdOn);
        this.closeDate = this.opportunityId.closeDate ? this.formatDate(this.opportunityId.closeDate) : "";
        this.expectedCloseDate = this.formatDate(this.opportunityId.expectedCloseDate);
      })
      .catch((response) => {
        console.log(response);
      })
      ]);

      // Now that both promises are resolved, set the salesPersonName
      const salesPerson = this.SalesPersonList.find(s => s.id === this.opportunityId.salespersonId);
      this.salesPersonName = salesPerson ? `${salesPerson.firstName} ${salesPerson.lastName}` : "";
    } catch (error) {
      console.error("Failed to load data:", error);
    }
  }

};
</script>
